import { defineStore } from "pinia";
import { ref } from "vue";
import Utils from "@/utils/util";

export const useGameStore = defineStore("game", () => {
  // 最近7天在玩的game
  const last7DaysGames = ref([]);
  const last7DaysSearchs = ref([]); //最近7天搜素

  // 从 localStorage 中加载数据
  const init7DaysGames = () => {
    const storedItems = Utils.$storageGet("last7DaysGames") || [];
    const filteredItems = storedItems.filter(item =>
      Utils.$isWithinLastSevenDays(item.date)
    );
    last7DaysGames.value = filteredItems;
    console.log("last7DaysGames-------",last7DaysGames)
  };
  // 从 localStorage 中加载数据
  const init7DaysSearchs = () => {
    const storedItems = Utils.$storageGet("last7DaysSearchs") || [];
    const filteredItems = storedItems.filter(item =>
      Utils.$isWithinLastSevenDays(item.date)
    );
    last7DaysSearchs.value = filteredItems;
  };
  const clearAll7DaysSearchs = () => {
    last7DaysSearchs.value = [];
    Utils.$storageClear("last7DaysSearchs");
  };
  const del7DaysSearchItem = item => {
    let index = last7DaysSearchs.value.findIndex(v => v.value === item.value);
    last7DaysSearchs.value.splice(index, 1);
  };

  // 添加新项目到列表中，并处理排序、去重及保留七天内数据
  const addLast7DaysGame = item => {
    item.date = new Date().toISOString();
    const existingIndex = last7DaysGames.value.findIndex(i => i.id === item.id);
    if (existingIndex !== -1) {
      last7DaysGames.value.splice(existingIndex, 1);
    }
    last7DaysGames.value.unshift(item);
    last7DaysGames.value = last7DaysGames.value.filter(item =>
      Utils.$isWithinLastSevenDays(item.date)
    );
    Utils.$storageSet("last7DaysGames", last7DaysGames.value);
  };
  const updateLast7DaysGame = item => {
    let index = last7DaysGames.value.findIndex(v => v.game_id === item.game_id);
    console.log(item)
    last7DaysGames.value[index] = item;
    Utils.$storageSet("last7DaysGames", last7DaysGames.value);
  };
  // 添加搜素哦到列表中，并处理排序、去重及保留七天内数据
  const addLast7DaysSearch = item => {
    item.date = new Date().toISOString();
    const existingIndex = last7DaysSearchs.value.findIndex(
      v => v.value === item.value
    );
    if (existingIndex !== -1) {
      last7DaysSearchs.value.splice(existingIndex, 1);
    }
    last7DaysSearchs.value.unshift(item);
    last7DaysSearchs.value = last7DaysSearchs.value.filter(item =>
      Utils.$isWithinLastSevenDays(item.date)
    );
    Utils.$storageSet("last7DaysSearchs", last7DaysSearchs.value);
  };
  // 初始化时调用加载本地数据
  init7DaysGames();
  init7DaysSearchs();
  return {
    last7DaysGames,
    addLast7DaysGame,
    updateLast7DaysGame,
    last7DaysSearchs,
    addLast7DaysSearch,
    del7DaysSearchItem,
    clearAll7DaysSearchs
  };
});
